const ShipmentGroupStatus = {
  New: 4,
};
const ShipmentStatus = {
  New: 3,
};
const PaymentStatus = {
  Pending: 1,
  PartiallyPaid: 29,
  Paid: 2,
};
const InvoiceType = {
  Shipment: 7,
  Order: 8,
  General: 11,
};
const PaymentType = {
  Aba: 9,
  Cash: 10,
};
const CurrencyType = {
  UsDollar: 12,
  VietDong: 13,
};
const OrderType = {
  Regular: 14,
  PlaceHolder: 15,
  Stale: 18,
  Preorder: 19,
};
const Warehouse = {
  UnitedStates: 16,
  Vietnam: 17,
};
const ShipmentType = {
  Air: 20,
  Sea: 21,
};
const ExpenseVendor = {
  Other: 26,
};
const ExpensePayment = {
  DebitCredit: 27,
};
const ExpenseType = {
  Other: 28,
};
export {
  ShipmentGroupStatus,
  ShipmentStatus,
  PaymentStatus,
  PaymentType,
  InvoiceType,
  CurrencyType,
  OrderType,
  Warehouse,
  ShipmentType,
  ExpenseVendor,
  ExpensePayment,
  ExpenseType,
};
